var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVariableNode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "currentColor",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.73528 2.33333H3.28369C2.743 2.33333 2.35285 2.47772 2.11323 2.7665C1.87361 3.06142 1.75379 3.60517 1.75379 4.39777V4.94153C1.75379 5.6481 1.66163 6.13964 1.47731 6.41612C1.29298 6.69261 0.994992 6.83085 0.583333 6.83085V7.75248C0.994992 7.75248 1.29298 7.89072 1.47731 8.16721C1.66163 8.44984 1.75379 8.94137 1.75379 9.64181V10.1948C1.75379 10.9812 1.87361 11.5219 2.11323 11.8168C2.35285 12.1056 2.743 12.25 3.28369 12.25H3.73528V11.5127H3.56018C3.20996 11.5127 2.96727 11.4359 2.83209 11.2823C2.69692 11.1348 2.62934 10.7754 2.62934 10.204V9.84456C2.62934 9.06425 2.53717 8.48978 2.35285 8.12113C2.17467 7.74633 1.86746 7.47292 1.43123 7.30088C1.86746 7.11656 2.17467 6.84007 2.35285 6.47142C2.53717 6.10277 2.62934 5.52829 2.62934 4.74799V4.37934C2.62934 3.81407 2.69692 3.45464 2.83209 3.30104C2.96727 3.14743 3.20996 3.07063 3.56018 3.07063H3.73528V2.33333Z",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.91665 2.33333H10.3682C10.9089 2.33333 11.2991 2.47772 11.5387 2.7665C11.7783 3.06142 11.8981 3.60517 11.8981 4.39777V4.94153C11.8981 5.6481 11.9903 6.13964 12.1746 6.41612C12.359 6.69261 12.6569 6.83085 13.0686 6.83085V7.75248C12.6569 7.75248 12.359 7.89072 12.1746 8.16721C11.9903 8.44984 11.8981 8.94137 11.8981 9.64181V10.1948C11.8981 10.9812 11.7783 11.5219 11.5387 11.8168C11.2991 12.1056 10.9089 12.25 10.3682 12.25H9.91665V11.5127H10.0918C10.442 11.5127 10.6847 11.4359 10.8198 11.2823C10.955 11.1348 11.0226 10.7754 11.0226 10.204V9.84456C11.0226 9.06425 11.1148 8.48978 11.2991 8.12113C11.4773 7.74633 11.7845 7.47292 12.2207 7.30088C11.7845 7.11656 11.4773 6.84007 11.2991 6.47142C11.1148 6.10277 11.0226 5.52829 11.0226 4.74799V4.37934C11.0226 3.81407 10.955 3.45464 10.8198 3.30104C10.6847 3.14743 10.442 3.07063 10.0918 3.07063H9.91665V2.33333Z",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.26562 5.25H5.82812C6.39062 5.25 6.39062 5.8125 6.96212 7.23394C7.51562 8.625 7.51562 9.1875 8.07812 9.1875H8.64062",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.70312 9.1875C5.54688 9.1875 6.39062 8.0625 6.95312 7.21875C7.51562 6.375 8.35938 5.25 9.20312 5.25",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_54"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVariableNode);
export default __webpack_public_path__ + "static/media/variableNode.e8c212cef1e9a2348abdc5be6f564870.svg";
export { ForwardRef as ReactComponent };